export default "__VITE_ASSET__baba61a5__"